/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialogue_List_Export_Forced_SubtitlesInputs */



/**
* | output |
* | --- |
* | "Forced Subtitles" |
*
* @param {Dialogue_List_Export_Forced_SubtitlesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_forced_subtitles = /** @type {((inputs?: Dialogue_List_Export_Forced_SubtitlesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_Forced_SubtitlesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sous-titres forcés")
	if (locale === "de") return /** @type {LocalizedString} */ ("Erzwungene Untertitel")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sottotitoli forzati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Принудительные субтитлы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Subtítulos forzados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("强制字幕")
	if (locale === "ja") return /** @type {LocalizedString} */ ("強制字幕")
	if (locale === "hi") return /** @type {LocalizedString} */ ("जबरन उपशीर्षक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Legendas forçadas")
	return /** @type {LocalizedString} */ ("Forced Subtitles")
});